import { Color } from "@jmc/solid-design-system/src/components/molecules/HeaderHero/HeaderHero";
import { CMSBlock } from "@types";

import { colorMap } from "./cms-mapper/colorMap";

export const lastSectionBackground = (content: CMSBlock[]): Color => {
    return colorMap.get(content?.[content?.length - 1]?.section?.background_color?.toLowerCase()) as Color;
};
